import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

// our components
import TrackingDrawer from './TrackingDrawer'
import NorowsData from './NorowsData'
import Notification from './Notification'
import Carrier from './Carrier'
import OrderStatus from './OrderStatus'
import Customer from './Customer'
import CarrierTracking from './CarrierTracking'
import Printer from './Printer'

// mui components
import {
    Typography,
    FormControl,
    Pagination,
    Card,
    CardContent,
    Stack,
    Tooltip,
    IconButton,
    Button,
    Backdrop,
    CircularProgress,
    Drawer,
    Box,
    Divider,
    CardHeader,
    Paper
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import Date from './Date'

import { fetchManifestDetail, resetManifestDetailNotifications } from '../../pages/ManifestDetail/manifestdetailSlice';
import { doGetDeliveries } from '../Reports/Deliveries/deliveriesSlice';
import { fetchCustomerDetails } from '../../pages/Reports/Deliveries/trackingEventsSlice';
import {
    fetchOrderDetail
} from '../../pages/OrderDetail/orderdetailsSlice';
import { fetchHubs } from './hubslice';
import OrderDrawer from '../../pages/General/OrderDrawer'
import WidthMaximize from './WidthMaximize'

// Reusable standard layout styling dictionary configuring premium outlined enterprise inputs
const enterpriseDrawerSelectStyles = {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #E2E8F0',
    padding: '6px 10px',
    fontSize: '13px',
    color: '#334155',
    fontWeight: 600,
    outline: 'none',
    cursor: 'pointer',
    transition: 'all 0.15s ease-in-out',
    '&:hover': {
        borderColor: '#CBD5E1',
        backgroundColor: '#F8FAFC'
    },
    '&:focus': {
        borderColor: '#1976d2',
        boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
    }
};

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    boxShadow: 'unset',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    color: theme.palette.text.secondary,
    height: '100%'
}));

const PendingShipmentsDrawer = ({ visible, manifestId, pendingShipmentsOnClose, shipmentType }) => {
    const dispatch = useDispatch();
    const deliveries = useSelector(state => state.deliveries);
    const profile = useSelector(state => state.auth);
    const [meta, setMeta] = useState(deliveries.deliveriesData.meta);
    const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [trackingMessage, setTrackingMessage] = useState(null);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [drawerWidth, setDrawerWidth] = useState("80%");
    
    const orderCallback = (item) => {
        dispatch(fetchOrderDetail(item));
        setOrderDrawerVisible(true)
    }
    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };
    const ondrawerclose = () => {
        pendingShipmentsOnClose(false)
    }

    console.log(shipmentType);

    const columns = [
        {
            field: 'order.id',
            headerName: 'Order',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Typography 
                        variant="body2" 
                        onClick={e => { orderCallback(params.row.order.id) }}
                        sx={{ 
                            color: '#1976d2', 
                            cursor: 'pointer', 
                            fontWeight: 700,
                            fontSize: '13.5px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            height: '100%',
                            '&:hover': { textDecoration: 'underline', color: '#115293' }
                        }}
                    >
                        {params.row.order.id}
                    </Typography>
                );
            }
        },
        {
            field: 'shipment.k',
            headerName: 'Tracking Number',
            minWidth: 180,
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                let tracking_number = (params.row.shipment && params.row.shipment.k
                    && typeof params.row.shipment.k !== "undefined" && params.row.shipment.k !== null)
                    ? params.row.shipment.k : "";
                let carrier_name = (params.row.shipment && params.row.shipment.v && params.row.shipment.v.label && params.row.shipment.v.label.carrier_name
                    && typeof params.row.shipment.v.label.carrier_name !== "undefined" && params.row.shipment.v.label.carrier_name !== null)
                    ? params.row.shipment.v.label.carrier_name : "";
                let message = (params.row.shipment && params.row.shipment.v && params.row.shipment.v.manifest &&
                    params.row.shipment.v.manifest.is_closed === false) ? "This shipment manifest is not yet closed" : null;
                let tracking = { "tracking_number": tracking_number, "carrier_name": carrier_name }
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <CarrierTracking trackingItems={tracking} dispatchCallback={trackingCallback} carrierImageWidth="60px" message={message} />
                    </Box>
                )
            }
        },
        {
            field: 'shipment.v.status',
            headerName: 'Shipment Status',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row && params.row.shipment && params.row.shipment.v && params.row.shipment.v.status) {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <OrderStatus orderStatus={params.row.shipment.v.status} />
                        </Box>
                    )
                }
            }
        },
        {
            field: 'customer.first_name',
            headerName: 'Customer',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                let name = ""
                if (params.row.customer && typeof params.row.customer.first_name !== "undefined" && params.row.customer.first_name !== null) {
                    name = params.row.customer.first_name;
                }
                if (params.row.customer && typeof params.row.customer.last_name !== "undefined" && params.row.customer.last_name !== null) {
                    name = name + " " + params.row.customer.last_name
                }
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <Customer name={name} />
                    </Box>
                )
            }
        },
        {
            field: 'shipment.v.product_info.actual_weight',
            headerName: 'Weight',
            width: 80,
            resizable: false,
            renderCell: (params) => {
                let weightVal = "-";
                if (params.row && params.row.shipment && params.row.shipment.v && params.row.shipment.v.product_info && params.row.shipment.v.product_info.actual_weight) {
                    weightVal = params.row.shipment.v.product_info.actual_weight;
                }
                return (
                    <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {weightVal}
                    </Typography>
                );
            }
        },
        {
            field: 'shipment.v.created_at',
            headerName: 'Date',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row && params.row.shipment && params.row.shipment.v && params.row.shipment.v.created_at) {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Date date={params.row.shipment.v.created_at} />
                        </Box>
                    )
                } else {
                    return <Typography variant="body2" sx={{ color: '#94A3B8', display: 'inline-flex', alignItems: 'center', height: '100%' }}>-</Typography>;
                }
            }
        }]

    useEffect(() => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: 10,
                start_date: "",
                end_date: "",
                order_id: "",
                order_status: [],
                receiver_province: "",
                receiver_country_code: "",
                tracking_number: "",
                carrier_name: [],
                platform_tags: [],
                customer_name: "",
                goods_out_note: "",
            }
        });
    }, [dispatch, manifestId])


    useEffect(() => {
        if (manifestId !== '') {
            dispatch(doGetDeliveries({
                ...meta,
                ...{
                    "shippingchimp_manifest_number": manifestId,
                    "shipment_type": shipmentType
                }
            }))
        }
    }, [manifestId, shipmentType, meta])

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    function CustomTotalRows() {
        return (
            <Typography variant="body2" sx={{ color: '#64748B', fontWeight: 600, fontSize: '13px' }}>
                Showing {deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data && deliveries.deliveriesData.data.length} of {(deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.total) ? deliveries.deliveriesData.meta.total : 0}
            </Typography>
        );
    }


    function CustomPagesizeoptions() {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" sx={{ color: '#64748B', fontWeight: 600, fontSize: '13px' }}>
                    Show
                </Typography>
                <select
                    value={meta && meta.per_page}
                    onChange={onChangePerPage}
                    style={enterpriseDrawerSelectStyles}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
                <Typography variant="body2" sx={{ color: '#64748B', fontWeight: 600, fontSize: '13px' }}>
                    entries
                </Typography>
            </Box>
        );
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, borderBottom: '1px solid #E2E8F0', bgcolor: '#FFFFFF' }}>
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2, borderTop: '1px solid #E2E8F0', bgcolor: '#F8FAFC' }}>
                <Pagination
                    color="primary"
                    shape="circular"
                    size="small"
                    page={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.current_page}
                    count={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.last_page}
                    onChange={onChangePagination}
                    sx={{
                        '& .MuiPaginationItem-root': { fontWeight: 600 },
                        '& .MuiPaginationItem-root.Mui-selected': { backgroundColor: '#1976d2', color: '#FFFFFF' }
                    }}
                />
            </Box>
        );
    }

    const trackingCallback = (carriername, trackingNumber, message = null) => {
        setTrackingMessage(message)
        let apikey = (profile && profile.profile && profile.profile.api_token) ? profile.profile.api_token : "";
        const data = { 'tracking_number': trackingNumber }
        dispatch(fetchCustomerDetails(data, apikey))
        setTrackingDrawerVisible(true)
    }
    const onClose = (values) => {
        setTrackingDrawerVisible(false);
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: drawerWidth, bgcolor: '#F8FAFC' },
                }}
            >
                <Box sx={{ p: 4, boxSizing: 'border-box' }}>
                    <Card 
                        sx={{ 
                            width: '100%', 
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                            overflow: 'hidden'
                        }} 
                        className="sc--cardhead--details"
                    >
                        <Box sx={{ width: '100%', background: '#fff' }}>
                            <CardHeader 
                                title={
                                    <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px', m: 0 }}>
                                        Shipment Details
                                    </Typography>
                                } 
                                action={
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <WidthMaximize
                                            defaultWidth="80%"
                                            onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                        />
                                        <Tooltip title="Close Drawer" placement="top">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#64748B', 
                                                    borderRadius: '8px', 
                                                    border: '1px solid #E2E8F0',
                                                    p: 0.75,
                                                    transition: 'all 0.15s ease-in-out',
                                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B', borderColor: '#CBD5E1' }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                }
                                sx={{ p: 2.5, backgroundColor: '#FFFFFF', borderBottom: '1px solid #E2E8F0' }}
                            />
                            
                            <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                                <DataGrid
                                    sx={{
                                        border: 'none',
                                        backgroundColor: '#FFFFFF',
                                        overflow: 'hidden',
                                        '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                                        '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                                        '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                        '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                        '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                        '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                    }}
                                    getRowId={(row) => row._id + Math.random()}
                                    rows={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data || []}
                                    columns={columns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    sortingMode="server"
                                    onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                                    sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                                    disableRowSelectionOnClick
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        pagination: CustomPagination,
                                        toolbar: CustomToolbar,
                                        noRowsOverlay: NorowsData
                                    }}
                                    loading={
                                        !!(deliveries && deliveries.deliveriesData.loading)
                                    }
                                />
                            </Box>
                        </Box>
                    </Card>
                    
                    <TrackingDrawer
                        visible={trackingDrawerVisible} message={trackingMessage} onClose={onClose}
                    />
                    <OrderDrawer
                        visible={orderDrawerVisible} onClose={orderOnClose}
                    />
                </Box>
            </Drawer >
        </>
    )
}

export default PendingShipmentsDrawer;